import { AddEditRoomState, AddEditRoomActionTypes, ADD_EDIT_ROOM_REQUEST, ADD_EDIT_ROOM_SUCCESS, ADD_EDIT_ROOM_FAILURE } from "store/reducers/room/add-edit-room/types";

const defaultState: AddEditRoomState = {
  isLoading: false,
  errorMessage: ""
};

export default function addEditRoom(state = defaultState, action: AddEditRoomActionTypes): AddEditRoomState {
  switch (action.type) {
    case ADD_EDIT_ROOM_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case ADD_EDIT_ROOM_SUCCESS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        errorMessage: ""
      };
    case ADD_EDIT_ROOM_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: ""
      };
    default:
      return state;
  }
};